interface NameValuePair<T> {
  name: string;
  value: T;
}

export default NameValuePair;
